module.exports = __webpack_public_path__ + "img/3.e2a78630.jpg";